import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { FlowTestsService } from "../flow-tests.service";
import { LogicTreeTest } from "../../handlers/logic-tree-tests-handler.service";

@Component({
  selector: "app-flow-tests-list",
  templateUrl: "./flow-tests-list.component.html",
  styleUrls: ["./flow-tests-list.component.scss"],
})
export class FlowTestsListComponent implements OnInit {
  displayedColumns: string[] = [
    "id",
    "flow",
    "status",
    "created_at",
    "completed_at",
    "actions",
  ];
  dataSource = new MatTableDataSource<LogicTreeTest>([]);
  isLoading = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private flowTests: FlowTestsService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  load(): void {
    this.isLoading = true;
    this.flowTests.list().subscribe({
      next: (records) => {
        // API already sorts by created_at DESC; defensive resort in case
        // something reorders in transit.
        this.dataSource.data = (records || []).slice().sort((a, b) => {
          return (
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
          );
        });
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  flowName(row: LogicTreeTest): string {
    return row.logic_tree?.name || `Flow #${row.logic_tree_id}`;
  }

  createTest(): void {
    this.router.navigate(["/flow-tests", "create"]);
  }

  viewTest(row: LogicTreeTest): void {
    this.router.navigate(["/flow-tests", row.id]);
  }

  deleteTest(row: LogicTreeTest): void {
    if (!confirm(`Delete flow test #${row.id}?`)) return;
    this.flowTests.remove(row.id).subscribe({
      next: () => this.load(),
    });
  }
}
